import { useMutation, useQuery } from "@tanstack/react-query";
import UserProfileApi from "../routes/userProfile";
import { authLogger } from "../Utils/logger";

export const useGetProfile = (enabled = true) => {
  return useQuery({
    queryKey: ["userProfile"],
    queryFn: async () => {
      try {
        authLogger.apiRequest("GET", "/user/profile");
        const response = await UserProfileApi.getProfile();
        authLogger.apiResponse("GET", "/user/profile", response, 200);

        // Handle the response structure - extract user from data.data.user
        const user = response?.data?.user;
        if (!user || !user.id) {
          throw new Error("Invalid or missing user data");
        }

        return user;
      } catch (error) {
        authLogger.apiError(
          "GET",
          "/user/profile",
          error,
          error.response?.status,
        );
        throw error;
      }
    },
    enabled, // Only run query when enabled is true
    retry: 1, // Only retry once on failure
    staleTime: 5 * 60 * 1000, // Consider data fresh for 5 minutes
    cacheTime: 10 * 60 * 1000, // Keep in cache for 10 minutes
  });
};
